import { Suspense } from 'react';
import { Navigate, Outlet, generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { MLB_PLAY_EVENTTYPE } from '@sorare/core/src/constants/__generated__/routes';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';
import { useLastVisitedEventType } from '@sorare/gameplay/src/hooks/useLastVisitedEventType';
import { getValidEventType } from '@sorare/gameplay/src/lib/so5';

import type { LayoutParams } from './__generated__/routeParams';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;
const PlayProLayout = () => {
  const { eventType } = useTypedParams<LayoutParams>();
  const { lastVisitedEventType, setLastVisitedEventType } =
    useLastVisitedEventType();

  if (lastVisitedEventType !== eventType) {
    setLastVisitedEventType(eventType);
  }

  if (eventType.toLowerCase() !== getValidEventType(eventType).toLowerCase()) {
    return (
      <Navigate
        to={generatePath(MLB_PLAY_EVENTTYPE, {
          eventType: getValidEventType(eventType).toLowerCase(),
        })}
      />
    );
  }

  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayProLayout;
